import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '我的海洋世界'
    },
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    meta: {
      title: '小游戏PK赢赏金'
    },
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/gamelist',
    name: 'gamelist',
    meta: {
      title: '彩贝小游戏'
    },
    component: () => import('../views/game/GameList.vue')
  },
  {
    path: '/exchange',
    name: 'exchange',
    meta: {
      title: '彩贝兑换'
    },
    component: () => import('../views/game/ExChange.vue')
  },
  {
    path: "/caibeirecord",
    name: "caibeirecord",
    meta: {
      title: "兑换明细",
    },
    component: () => import("../views/game/recordList.vue"),
  },
  {
    path: "/coupons",
    name: "coupons",
    meta: {
      title: "我的卡券",
    },
    component: () => import("../views/game/myCoupons.vue"),
  },
  {
    path: "/materialList",
    name: "materialList",
    meta: {
      title: "实物订单",
    },
    component: () => import("../views/game/materialList.vue"),
  },
  {
    path: "/caibeilist",
    name: "caibeilist",
    meta: {
      title: "收支明细",
    },
    component: () => import("../views/game/caibeiList.vue"),
  },
  {
    path: "/jinbeiList",
    name: "jinbeiList",
    meta: {
      title: "收支明细",
    },
    component: () => import("../views/game/jinbeiList.vue"),
  },
  {
    path: "/bindIng",
    name: "bindIng",
    meta: {
      title: "绑定支付宝账号",
    },
    component: () => import("../views/game/bindIng.vue"),
  },
  {
    path: "/SeizeTreasuress",
    name: "SeizeTreasuress",
    meta: {
      title: "彩贝好运夺宝",
    },
    component: () => import("../views/game/SeizeTreasures.vue"),
  },
  {
    path: "/comModity",
    name: "comModity",
    meta: {
      title: "彩贝好运夺宝",
    },
    component: () => import("../views/game/comModity.vue"),
  },
  {
    path: "/luckDraw",
    name: "luckDraw",
    meta: {
      title: "幸运大抽奖",
    },
    component: () => import("../views/activity/luckDraw.vue"),
  },
  {
    path: "/comMaterial",
    name: "comMaterial",
    meta: {
      title: "彩贝实物兑换",
    },
    component: () => import("../views/game/comMaterial.vue"),
  },
  {
    path: "/newActivity",
    name: "newActivity",
    meta: {
      title: "新人活动",
    },
    component: () => import("../views/game/newActivity.vue"),
  },
  {
    path: "/interestList",
    name: "interestList",
    meta: {
      title: "明细",
    },
    component: () => import("../views/game/interestActivity/interestList.vue"),
  },
  {
    path: "/interestActivity",
    name: "interestActivity",
    meta: {
      title: "新人活动",
    },
    component: () => import("../views/game/interestActivity/interestActivity.vue"),
  },
  {
    path: "/interestGz",
    name: "interestGz",
    meta: {
      title: "活动规则",
    },
    component: () => import("../views/game/interestActivity/interestGz.vue"),
  },
  {
    path: "/kkwActivity",
    name: "kkwActivity",
    meta: {
      title: "新人活动",
    },
    component: () => import("../views/game/kkwActivity.vue"),
  },
  {
    path: "/ArenaCompetition",
    name: "ArenaCompetition",
    meta: {
      title: "",
    },
    component: () => import("../views/game/ArenaCompetition.vue"),
  },
  {
    path: "/InviteFriends",
    name: "InviteFriends",
    meta: {
      title: "邀请好友",
    },
    component: () => import("../views/game/InviteFriends.vue"),
  },
  {
    path: "/detailedList",
    name: "detailedList",
    meta: {
      title: "邀请好友",
    },
    component: () => import("../views/game/detailedList.vue"),
  },
  {
    path: "/goldenList",
    name: "goldenList",
    meta: {
      title: "领奖记录",
    },
    component: () => import("../views/golden/goldenList.vue"),
  },
  {
    path: "/rewardSettings",
    name: "rewardSettings",
    meta: {
      title: "奖励设置",
    },
    component: () => import("../views/golden/rewardSettings.vue"),
  },
  {
    path: "/goldenHome",
    name: "goldenHome",
    meta: {
      title: "兑换中心",
    },
    component: () => import("../views/golden/goldenHome.vue"),
  },
  {
    path: "/undersea",
    name: "undersea",
    meta: {
      title: "海底寻宝",
    },
    component: () => import("../views/Undersea/underseaIndex.vue"),
  },
  {
    path: "/underseaGame",
    name: "underseaGame",
    meta: {
      title: "海底寻宝",
    },
    component: () => import("../views/Undersea/underseaGame.vue"),
  },
  {
    path: "/idAuthentication",
    name: "idAuthentication",
    meta: {
      title: "身份认证",
    },
    component: () => import("../views/idAuthentication.vue"),
  },
  {
    path: "/explanation",
    name: "explanation",
    meta: {
      title: "劳务提现扣税规则",
    },
    component: () => import("../views/taxExplanation.vue"),
  },
]//

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  }
  next();
})

export default router
